import { Component,OnInit  } from '@angular/core';
import { NavController, Refresher,LoadingController,ToastController,NavParams} from 'ionic-angular';
import { DTOAcompanharPix } from '../../dto/dtoAcompanharPix';
import { PedidoDAO } from '../../daos/pedido-dao';
import { DTOInformacaoUsuario } from '../../dto/dtoInfomacaoUsuario';
import { VisualizaImagemPage } from '../visualiza-imagem/visualiza-imagem';
import _ from 'lodash';

@Component({
    selector: 'page-lista-pix',
    templateUrl: 'lista-pix.html'
})
export class ListaPixPage implements OnInit {
    public dataInicial: string = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString();   
    public dataFinal: string = new Date().toISOString();
    public infNumCartela: string;
    public acompanharPix: DTOAcompanharPix[] = [];
    public acompanharPixOriginal: DTOAcompanharPix[] = [];
    public usuario: DTOInformacaoUsuario = new DTOInformacaoUsuario();
    public statusPed: string;
    public base64Image: string = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8AAAAMcAQMAAACl5F6MAAAABlBMVEW8vsDn6OnyCdevAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEbUlEQVR4AezBMQEAAADCoPVP7WsIoAcAAAAAAAAAAAAAAAAAAAAAAIydO0iOk4eCAGyVXNEuukF0FB1NHE1H0RG0ZEHRf5A99WYMk1T+Kvolw+vVjBf+CkMLoRCFWQkuqCquB3QOOQKrCpwBKJ1i6Jxk/EzTubaArgAHQOeyjhu8aMEafUrYolLjLRMfLrpw5cMYadeBnTLcrwN7ZXi+DhyuCi8GG/xy8Gyw3SRe7n7cLzfnajah5z87keFJ//lYf0WAAq+vv+rDX+fir+zpr2Xqr95qrle/ywr9OxX+/nF19fGRmR/yrzCJCudRqNHiNDHhIlquTBgCF2aX3V2BwYT9nUYdNoNojnqjiKJ56q0xiRaok4EsWqQO2EW0RJ3wQbTMvDc6iFaYswEvkx5Hnf8E0Tx1xhcfj3gh1lhOLHVWnx8vLvBq/FAnYpGBhwEElVfjhyETjVjj5bFanATpLrHIcpDkIstpJRdZLmRykaW63CLLMZKLLGeVXGS5jvlFluZKq8k1lnGMXGMZuck1lnsVu8ZydybXWOYj5BrLDIxcY5lz8mrML/JupPIC02osf3tyjeVqY9dYikys8QlTAUIsFovFYrFYLJaIP8hq8D4GG2ywwQYbbLDBBhtssMEGG2ywwQYb3N9+G/ePwQYbbLDBBhtssMEGG5yhA3ugqcARmFXgDKwqcAGgAsu+J1zYy94UXDjIRxosH+crwUm2euHCWX43Fy7YciUYI9N1YIeRavDpsMdIM9jgs+BOh4PBavA3ras6aMFRC06TEpyrLsy/H5emBKOrwvxZpsOsA3ssOk8SQQ9edZ4WI6DzfJwU4Ym/FCE7ofFXfQoJlnUugRsHdl9GTKBzlxRF6vzVW9kngr5eLTB5hT6MUhPgLfdDRhwQCQ79TQXe756tAWcp10XgIuMYF8aWxoedLtz5sB/wzIeDLrzw4QiRqHBSgOvnwLWFCrc7eCLCbnwrXFh2ZMdHKhEOyx3ciHBch8OHE2TtCZ0IZ0wCz1S4jhGTDhc0ecN9IcLja/qEVwIswqwC+/H3zfgMDw7j95cbPBFg+YEKnIaGWyoNzpvmcEujws0rwGX7LnCnwWOgDLhlZsFuaJEP+zFCC7yw4DCAhFtWFhwHl/lwwpeowRMJzlpw+QpXEgwl2O3gxoH9Du4cOOzgmQNHLTjt4OXF4byDVw5csAsHhhLssM/EgD32qQw4aMER+zQtuDPgpAVn7DMz4IJ9FgYMJdgdwSsB9jgKAQ5acDyEJy24ng8nLTgfwu18uBzC/XwYSrA7hmfCeyCHWU6Hw18Gr4R3fY5zOpy04PwEngj/KfYw9WwYSrB7BjfCW4qH6a8Kh2fwTHgF9jDLyXDSgvMzeKW8UX6Uk2Eowe45PL0m7J/D9VQ4aMG/isH/JwYbbLDBBhtssMEGG2ywtz3K/2tvDmQAAAAABvlbn+NbCSQWi8VisVgsFovFYrFYLBYvAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEHVJjR5bJLd8AAAAASUVORK5CYII=';
    constructor(public navCtrl: NavController,private _loadingCtrl: LoadingController,
        private _toastCtrl: ToastController,private _pedidoDao: PedidoDAO,_navParams: NavParams) {   
            this.usuario = _navParams.get('usuario');
 
    }

    ngOnInit(): void {
        this.obterAcompanhamento();
    }

    consultar() {   
        this.obterAcompanhamento();
    }

    searchNumCartela() {        
     //console.log('teste'+ this.infNumCartela);
    }

    public obterAcompanhamento(refresher?: Refresher): void {
        let load = this._loadingCtrl.create({ content: 'Obtendo Acompanhamento...' });
        if (!refresher)
            load.present();
            let idUsu = this.usuario.IdUsuario;
            if (this.usuario.Perfil == 'ADMINISTRADOR'){
                idUsu  = 0;
            }
            this.dataInicial = this.dataInicial.substring(0, 10);
            this.dataFinal = this.dataFinal.substring(0, 10);
            
            let numCartela='0';
            if (this.infNumCartela === undefined) numCartela = '0'
            else if (this.infNumCartela.length > 0) numCartela = this.infNumCartela;

            this._pedidoDao.listaPix(this.usuario.Empresa.Id, idUsu , false, this.dataInicial, this.dataFinal,numCartela).then(lstPix => {        
            this.acompanharPixOriginal = lstPix;
            
            this.acompanharPix = lstPix.filter(a => _.isEqual(a.Status, 'Em Análise')); 
    
            if (!refresher) load.dismiss(); else refresher.complete();
        }).catch(error => {
            console.error(error);
            if (!refresher) load.dismiss(); else refresher.complete();
            this._toastCtrl.create({
                message: 'Ocorreu um erro ao tentar obter os acompanhamento pedido. Tente novamente!',
                duration: 3000
            }).present();        
        });
    
    }


    visualizarImagem(obj:string){
        this.navCtrl.push(VisualizaImagemPage,{usu: this.usuario, img: obj  });
    }


    public consultaStatusPedido(): void {
        var lista = this.acompanharPixOriginal
        this.acompanharPix = lista.filter(a => _.isEqual(a.Status, this.statusPed)); 
        
    }

    public visualizarInfoPix(dtoAcompanharPix: DTOAcompanharPix): void {
        if (dtoAcompanharPix.VeInfoPix == undefined)
            dtoAcompanharPix.VeInfoPix = true;
        else if (dtoAcompanharPix.VeInfoPix)
            dtoAcompanharPix.VeInfoPix = false;
        else dtoAcompanharPix.VeInfoPix = true ;
        
    }

    


}


// WEBPACK FOOTER //
// ./src/pages/lista-pix/lista-pix.ts